import LastName from './LastName';

export default LastName;
export { LastNameV2 } from './LastNameV2';
